import { ReactNode, useEffect, useRef, Fragment } from 'react';
import Slider from 'react-slick';
import { SECOND } from 'core/common/constants';
import { ReviewCard } from 'core/flow/entities/Content';
import { Carousel, CarouselSettings } from '../Carousel';
import { WrapperStyled } from './styled';

type ReviewsCarouselProps = {
  content: { list: ReviewCard[] };
  settings?: CarouselSettings;
  shouldPlayAnimation?: boolean;
  className?: string;
  renderReviewCard: (props: ReviewCard) => ReactNode;
};

const defaultCarouselSettings: CarouselSettings = {
  speed: 600,
  infinite: false,
  slidesToShow: 1.1,
  arrows: false,
  pauseOnHover: false,
  autoplaySpeed: 5 * SECOND,
};

export const ReviewsCarousel = ({
  content,
  className,
  shouldPlayAnimation = false,
  settings = {},
  renderReviewCard,
}: ReviewsCarouselProps) => {
  const mergedSettings = { ...defaultCarouselSettings, ...settings };

  const ref = useRef<Slider>(null);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    if (shouldPlayAnimation) {
      ref.current.slickPlay();
      return;
    }

    ref.current.slickPause();
  }, [shouldPlayAnimation, ref]);

  if (!content?.list) return null;

  return (
    <WrapperStyled className={className}>
      <Carousel {...mergedSettings} ref={ref}>
        {content.list.map((review) => (
          <Fragment key={review.userName}>{renderReviewCard(review)}</Fragment>
        ))}
      </Carousel>
    </WrapperStyled>
  );
};
